import Button from 'assets/components/button/Button';
import ThemeButtonMenuItem from 'assets/components/button/themes/Theme.Button.MenuItem';
import Icon from 'assets/components/icon/Icon';
import { getLocales } from 'assets/locales/Locale';
import DropdownButton from 'assets/templates/dropdownButton/DropdownButton';
import ThemeDropdownButtonPopup from 'assets/templates/dropdownButton/themes/Theme.DropdownButton.Popup';
import { OrderType } from 'config/Api.Config';

type SortByIdDropdownProps = {
  onSort(props: Api.IDefaultListRequest): void;
};
export default function SortByIdDropdown(props: SortByIdDropdownProps) {
  const { lang } = getLocales();
  return (
    <DropdownButton
      buttonMedia={<Icon class="fas-sort" />}
      horizontalPosition="auto_fixed"
      verticalPosition="auto_fixed"
      htmlElementProps={{ title: lang.sort }}
      subcomponents={ThemeDropdownButtonPopup}
      dropdownOptions={
        <>
          <Button
            class={ThemeButtonMenuItem}
            render={lang.newerFirst}
            media={<Icon class="fas-caret-up" />}
            onClick={props.onSort}
            data={{
              orderBy: undefined,
              orderType: undefined,
            }}
          />
          <Button
            class={ThemeButtonMenuItem}
            render={lang.olderFirst}
            media={<Icon class="fas-caret-down" />}
            onClick={props.onSort}
            data={{
              orderBy: 'id',
              orderType: OrderType.asc,
            }}
          />
        </>
      }
    />
  );
}
